import { Address } from 'viem';

import {
  AvailableChainIdType,
  CHAIN_ID,
  ZERO_ADDRESS,
} from '@constants/common/chain.constants';

import { Token } from '@app-types/common/token.types';

export enum TokenSymbol {
  BNB = 'BNB',
  EMP = 'EMP',
  ESHARE = 'eSHARE',
  WBNB = 'WBNB',
  FTM = 'FTM',
  ETH = 'ETH',
  AVAX = 'AVAX',
  PLS = 'PLS',
  USDC = 'USDC',
  USDEX_PLUS = 'USDEX+',
  GDEX = 'GDEX',
  WETH = 'WETH',
  VAULT_INVESTMENTS = 'VAULT INVESTMENTS',
  MT = 'MT',
}

export const NATIVE_TOKEN: Record<AvailableChainIdType, Token> = {
  [CHAIN_ID.BASE]: new Token(
    CHAIN_ID.BASE,
    ZERO_ADDRESS,
    18,
    TokenSymbol.ETH,
    false,
    TokenSymbol.ETH,
  ),
};

export const TOKENS = {
  [CHAIN_ID.BASE]: {
    [TokenSymbol.ETH]: NATIVE_TOKEN[CHAIN_ID.BASE],
    [TokenSymbol.WETH]: new Token(
      CHAIN_ID.BASE,
      '0x4200000000000000000000000000000000000006',
      18,
      TokenSymbol.WETH,
      false,
      TokenSymbol.WETH,
    ),
    [TokenSymbol.MT]: new Token(
      CHAIN_ID.BASE,
      '0x1362a9046bb76feddbb4e81c5f07467a14174692',
      18,
      TokenSymbol.MT,
      false,
      'MockToken',
    ),
    [TokenSymbol.ESHARE]: new Token(
      CHAIN_ID.BASE,
      '0xb7c10146ba1b618956a38605ab6496523d450871',
      18,
      TokenSymbol.ESHARE,
      false,
      'ESHARE',
    ),
    [TokenSymbol.USDC]: new Token(
      CHAIN_ID.BASE,
      '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      6,
      TokenSymbol.USDC,
      false,
      'USDC',
    ),
  },
} satisfies Record<AvailableChainIdType, Partial<Record<TokenSymbol, Token>>>;

export const MARKETPLACE_TOKEN = TOKENS[CHAIN_ID.BASE][TokenSymbol.ETH];
export const FUSION_NFT_NAME = 'Microgrid';

export const MAX_UINT256 = BigInt(
  '115792089237316195423570985008687907853269984665640564039457584007913129639935',
);

export enum TokenPair {
  USDC_ETH = 'USDC_ETH',
  ESHARE_ETH = 'ESHARE_ETH',
}

export const UNIV3_POOLS: Partial<
  Record<AvailableChainIdType, Record<TokenPair, Address>>
> = {
  [CHAIN_ID.BASE]: {
    [TokenPair.USDC_ETH]: '0xd0b53d9277642d899df5c87a3966a349a798f224',
    [TokenPair.ESHARE_ETH]: '0x0656cdf4539f412f542a8d8a029f7c6c5ce90d7b',
  },
};
